import styled from "styled-components";

export const LastOrderContainer = styled.div`
    flex: 12;
    border-radius: 10px;
    padding: 10px 20px;
    box-shadow: 1px 1px 1px 1px rgba(178, 177, 177, 0.12);
    background-color: #fff;
`;